import { uniqBy } from 'lodash';
import { Carrier, LocaleField } from 'common/types';

interface CarrierOption {
	id: string;
	name: LocaleField;
}

export const getUniqueCarrierOptions = (
	shopCarriers: Carrier[],
	oldCarrier?: CarrierOption,
): CarrierOption[] => {
	const shopCarrierOptions = shopCarriers.map(({ id, name }) => ({
		id,
		name,
	}));
	return !!oldCarrier?.id
		? uniqBy([...shopCarrierOptions, oldCarrier], (carrier) => carrier.id)
		: shopCarrierOptions;
};
